import { useEffect, useState } from "react";
import { Alert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import { Link, Navigate } from "react-router-dom";
import { PlaylistPreviewParser } from "./PlaylistPreviewParser";
import Header from "../../Header";
import { PlaylistRoutePaths } from "../PlaylistRoutePaths";
import { useTranslation } from "react-i18next";
import { rememberRecentPreview } from "./RecentPreviews";

interface Props {
  playlistIdentifier: string;
}

/**
 * Opens a preview from a link or QR code and adds it to the recent previews of the playlist index. If the playlist
 * with this id is in the cache (or arrives there later), the carousel shows that one instead.
 */
function PlaylistPreviewRoute({ playlistIdentifier }: Props) {
  const { t } = useTranslation();

  const [songIds] = useState(() =>
    new PlaylistPreviewParser().songIdsFromUrl(window.location.href),
  );
  const [isRemembered, setIsRemembered] = useState(false);

  // in an effect: remembering notifies the playlist index, which must not happen while rendering
  useEffect(() => {
    if (songIds) {
      rememberRecentPreview(playlistIdentifier, songIds);
      setIsRemembered(true);
    }
  }, [playlistIdentifier, songIds]);

  if (songIds) {
    return isRemembered ? (
      <Navigate
        to={PlaylistRoutePaths.toCarousel(playlistIdentifier)}
        replace
      />
    ) : null;
  }

  return (
    <>
      <Header />
      <br />
      <Alert color="danger" fade={false}>
        <h2 className={"light-header"}>
          <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
          {t("playlist.preview.errorTitle")}
        </h2>
        <span>{t("playlist.preview.errorMessage")}</span>
        <br />
        <br />
        <Link to="/">
          <FontAwesomeIcon icon={faHome} /> {t("playlist.linkProblem.overview")}
        </Link>
      </Alert>
    </>
  );
}

export default PlaylistPreviewRoute;
